module.exports = __webpack_public_path__ + "static/media/colorWheel.86de06ae.png";